<template>
  <div>
    <div class="centerbox">
      <headbox title="业务说明" bgColor="#fff"></headbox>
      <img src="@/assets/images/yewyshuoming.png" alt="" />
      <!-- <h1>货品定价</h1>
      <p>查看行情或曲线走势，填写<b>定价</b>相关信息：类别、克重、地址等，提交至中鑫金后台进行审核</p>
      <h1>上门取货</h1>
      <p>收到定价审核通过的短信后，通过“上门取货”寄送货品至本公司; 可通过“我的”—“货运投保”对运输过程进行投保</p>
      <h1>入库结算</h1>
      <p>中鑫金收到您的货物后会依照严格的流程进行清点，为您开具结算单，<b>请及时对结算单进行确认</b></p>
      <h1>确认打款</h1>
      <p>如果您对结算单有任何疑问，可致电人工客服进行咨询，待您<b>确认结算金额无误</b>后，中鑫金将飞速为您打款</p> -->
    </div>
  </div>
</template>
<script>
import headbox from "@/components/head.vue";
export default {
  components: {
    headbox
  }
};
</script>
<style lang="scss" scoped="true">
.centerbox {
  font-size: 28px;
  h1 {
    font-size: 36px;
    margin-bottom: 15px;
  }
  p {
    margin-bottom: 60px;
    b {
      font-weight: normal;
      color: #eca045;
    }
  }
}
</style>
